var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-update-form app__specified-form" },
    [
      _c("input-field", {
        attrs: { label: _vm.i18n.sale_update_news() },
        model: {
          value: _vm.form.title,
          callback: function($$v) {
            _vm.$set(_vm.form, "title", $$v)
          },
          expression: "form.title"
        }
      }),
      _vm._v(" "),
      _c("textarea-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }
        ],
        staticClass: "step__input-field",
        attrs: {
          label: _vm.i18n.sale_updates_textarea_label(),
          placeholder: _vm.i18n.sale_updates_textarea_placeholder(),
          maxlength: 250
        },
        model: {
          value: _vm.form.message,
          callback: function($$v) {
            _vm.$set(_vm.form, "message", $$v)
          },
          expression: "form.message"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap space-between" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: { click: _vm.createUpdate }
            },
            [_vm._v(_vm._s(_vm.i18n.sale_updates_add_note_bt()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              on: {
                click: function($event) {
                  return _vm.$emit(_vm.events.closeEvent)
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text_small text_description text_margin" }, [
        _vm._v(_vm._s(_vm.i18n.sale_updates_add_note_text()))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87de90f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87de90f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.AddForm.vue
// module id = XihT
// module chunks = 1